export default __webpack_public_path__ + "static/media/1640_all.4a5b4fad.webp";